var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('NotificationBubble',{directives:[{name:"show",rawName:"v-show",value:(!_vm.firstTimeLoading && _vm.totalDisconnects > 0),expression:"!firstTimeLoading && totalDisconnects > 0"}],attrs:{"total":_vm.totalDisconnects}})}
var staticRenderFns = []

export { render, staticRenderFns }